export function encodeQueryForStatisticsLink(query: string): string {
    return encodeURIComponent(`${query === '#EMPTY#' ? '' : query}`);
}
